export const IP_INFO_URL = "https://ipinfo.io?token=a449d70ad00a47"
export const SUPPORT_URL = process.env.REACT_APP_SUPPORT_URL
export const KNOWLEDGE_BASE_URL = "https://orimon.gitbook.io/docs/"
export const BLOG_BASE_URL = "https://blog.orimon.ai"
export const FEATURE_REQUEST_URL = "https://portal.leanbe.ai/orimon/ideas"
export const CHATBOT_URL = process.env.REACT_APP_CHATBOT_URL
export const POWERED_BY_URL =
  "https://orimon.ai/?utm_source=client_bot&utm_medium=chatbot&utm_campaign=powered_by_link"
export const LIVE_CHAT_SOCKET_URL = `${process.env.REACT_APP_BASE_SOCKET_URL}/liveConversation`
